import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import circleright from '../../assets/images/roadmap/road_circle_right.png';
import circle1 from '../../assets/images/roadmap/road1r.png';
import circle2 from '../../assets/images/roadmap/road2r.png';
import circle3 from '../../assets/images/roadmap/road3r.png';
import circle4 from '../../assets/images/roadmap/road4r.png';
import circle5 from '../../assets/images/roadmap/road5r.png';

import './road_styles/roadmile.css';

export default function RoadMile() {
  return (
    <>
      <Container className='mt-5 mb-5 roadmile'>
        <div className="roadmile_head text-center mb-5">
          <h3>HISTORICAL MILESTONES</h3>
        </div>
        <Row className='flex-row'>
          <Col lg={6} className="roadmile_col">
                <div className="para_road ms-auto">
                  <span>
                    The Virtual Exchange project was confirmed, and the official website was
                    launched on July 29, announcing the development of the Virtual Exchange plan.  
                  </span>  
                </div>
                <div className='row'>
                    <div className="para_road_img mb-5 d-flex justify-content-end mt-5">
                    <div className="text-right left_img">
                  <img src={circle2} alt="Circle towards right side" className='roadmile_cir' />
                  <span className='road_cir'>2021/10</span>  
                </div>
                    </div>
                </div>

                <div className="para ms-auto">
                  <span>
                    The Virtual Exchange project was confirmed, and the official website was
                    launched on July 29, announcing the development of the Virtual Exchange plan.  
                  </span>  
                </div>
                <div className='row'>
                    <div className="para_road_img mb-5 d-flex justify-content-end mt-5">
                    <div className="text-right left_img">
                  <img src={circle4} alt="Circle towards right side" className='roadmile_cir' />
                  <span className='road_cir'>2021/10</span>  
                    </div>
                    </div>
                </div>

                <div className="para ms-auto">
                  <span>
                    The Virtual Exchange project was confirmed, and the official website was
                    launched on July 29, announcing the development of the Virtual Exchange plan.  
                  </span>  
                </div>
                
          </Col>

          <Col lg={6} className='col_left_mile roadmile_col'>
                <div className="para_road_img2 mb-5 d-flex justify-content-start">
                  <div className='right_img'>
                   <img src={circle1} alt="Circle towards right side" />
                   <span>2021/10</span>
                  </div>  
                </div>
                <div className="para">
                  <span>
                    The Virtual Exchange project was confirmed, and the official website was
                    launched on July 29, announcing the development of the Virtual Exchange plan.  
                  </span>  
                </div>

                <div className="para_road_img2 mb-5 d-flex justify-content-start mt-5">
                  <div className="right_img">
                   <img src={circle3} alt="Circle towards right side" />
                   <span>2021/10</span>
                  </div>  
                </div>
                <div className="para">
                  <span>
                    The Virtual Exchange project was confirmed, and the official website was
                    launched on July 29, announcing the development of the Virtual Exchange plan.  
                  </span>  
                </div>

                <div className="para_road_img2 mb-5 d-flex justify-content-start mt-5">
                  <div className="right_img">
                   <img src={circle5} alt="Circle towards right side" />
                   <span>2021/10</span>  
                  </div>
                </div>
          </Col>  
        </Row>
      </Container>
    </>
  )
}